import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";

const KIDS_1 = "https://images.pexels.com/photos/10418368/pexels-photo-10418368.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const KIDS_2 = "https://images.pexels.com/photos/9428892/pexels-photo-9428892.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const PUP = "https://images.pexels.com/photos/5801/animal-dog-pet-cute.jpg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const PILLARS = [
  { n: "01", t: "Nutrition", b: "A premium, vet-formulated diet tailored to tiny tummies keeps our puppies thriving from their very first days." },
  { n: "02", t: "Socialization", b: "Daily play with our children and gentle exposure to everyday life create confident, affectionate companions." },
  { n: "03", t: "Veterinary Care", b: "Regular check-ups, vaccinations, and a written health guarantee give you complete peace of mind." },
  { n: "04", t: "Lifelong Support", b: "Our relationship never ends at delivery. We remain a phone call away for the entire life of your puppy." },
];

export default function Care() {
  return (
    <div data-testid="care-page">
      <PageHero
        eyebrow="Our Family"
        title={["Raised as family,", "not merchandise."]}
        subtitle="Every puppy grows up inside our home, cradled by our children and cherished as one of our own."
      />

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-24">
        <div className="grid lg:grid-cols-2 gap-8 items-stretch">
          <Reveal>
            <div className="relative overflow-hidden rounded-md h-full min-h-[420px]">
              <img src={KIDS_1} alt="Child cuddling puppy" className="h-full w-full object-cover" />
            </div>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="bg-[#F5E6E3] rounded-md p-10 md:p-14 h-full flex flex-col justify-center">
              <h2 className="font-heading text-4xl md:text-5xl font-light text-[#2A2118] leading-tight mb-6">
                Little hands, gentle hearts.
              </h2>
              <p className="text-[#5c5245] text-lg font-light leading-relaxed">
                From the moment they open their eyes, our puppies are surrounded by warmth. Our
                children read to them, nap beside them, and teach them that the world is a kind,
                loving place. This early tenderness shapes the sweet temperament every one of our
                puppies is known for.
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="bg-[#2A2118] text-[#FDFBF7] py-28">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <Reveal>
            <p className="label-eyebrow text-[#E6C5C0] mb-6">How We Care</p>
            <h2 className="font-heading text-4xl md:text-6xl font-light max-w-2xl leading-tight mb-16">
              Four pillars of a well-raised puppy.
            </h2>
          </Reveal>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
            {PILLARS.map((p, i) => (
              <Reveal key={p.n} delay={i * 0.1}>
                <div className="border-t border-white/15 pt-6">
                  <span className="font-heading text-5xl text-[#C8A98E]">{p.n}</span>
                  <h3 className="font-heading text-2xl mt-3 mb-2 text-[#FDFBF7]">{p.t}</h3>
                  <p className="text-[#d8c4b8] font-light text-sm leading-relaxed">{p.b}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24">
        <div className="grid lg:grid-cols-2 gap-8">
          <Reveal>
            <div className="relative overflow-hidden rounded-md">
              <img src={KIDS_2} alt="Family with puppy" className="w-full aspect-[4/3] object-cover" />
            </div>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="relative overflow-hidden rounded-md">
              <img src={PUP} alt="Teacup puppy" className="w-full aspect-[4/3] object-cover" />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
